import createFiltersStore from '@/stores/createFiltersStore'
import { DEFAULT_ACTIVE_MANAGEMENT_FILTERING } from '@/utils/constants'

export const useActiveManagementFiltersStore = createFiltersStore(
    'activeActiveManagementFilters',
    DEFAULT_ACTIVE_MANAGEMENT_FILTERING
)
